import firebase, { apps, database } from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";
import "firebase/analytics";
import "firebase/storage";
import { REALDB_CONSTANT } from "../Constant/FirebaseConstant";
import * as XLSX from "xlsx";
import { NotifyEvenuefy } from "../3rdParty";
import { RegionData } from "../Constant/RegionData";
import { SectionData } from "../Constant/SectionData";

const firebaseConfig = {
  apiKey: "AIzaSyBBgAbHlaczfUI-X1aKaQFIre8b1O7sfW8",
  authDomain: "iijs-floorplan.firebaseapp.com",
  databaseURL: "https://iijs-floorplan-default-rtdb.firebaseio.com",
  projectId: "iijs-floorplan",
  storageBucket: "iijs-floorplan.appspot.com",
  messagingSenderId: "144359212350",
  appId: "1:144359212350:web:d734da9f4f6f933e89986f",
  measurementId: "G-4ZFBF8M91S",
};

firebase.initializeApp(firebaseConfig);

export const firebaseApp = firebase;

export const auth = firebase.auth();

export const firestore = firebase.firestore();

export const realDB = firebase.database();

export const analytics = firebase.analytics();

export const storage = firebase.storage();

export const logoutUser = () => {
  return auth.signOut();
};

export const GetSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.SellerBaseData).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.SellerBaseData)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Base Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetSingleSellerBaseData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.SellerBaseData}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Base Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const GetAllSellersStallData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      // const snapshot = await realDB.ref(REALDB_CONSTANT.Sellersdata).get();
      const snapshot = await realDB
        .ref(REALDB_CONSTANT.Sellersdata)
        .once("value");
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Sellers Stall Data found!!");
        resolve({});
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};
export const GetSingleSellerStallData = (sellerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = await realDB
        .ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`)
        .get();
      if (snapshot.exists()) {
        resolve(snapshot.val());
      } else {
        console.warn("No Seller Stall Data found!!");
        resolve(null);
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const UpdateSellerStallData = (sellerId, payload, user, syncWithEvenufy = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !payload) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }
      if (syncWithEvenufy) {
        const result = await NotifyEvenuefy.allocated(NotifyEvenuefy.SellersDataToNotifyData(payload))
        // console.log(result)
        if (result.code != 200) {
          throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
        }
      }
      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.update(payload);
      const _nodeRef = realDB.ref(
        `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
      );
      let _pa = {
        ...payload,
      };
      if (user) {
        _pa = {
          ..._pa,
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        };
      }
      delete _pa.stallData;
      await _nodeRef.update(_pa);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const DeleteSellersStallData = (sellerId, sectionId, user, syncWithEvenufy = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!sellerId || !sectionId) {
        throw ({ code: "Parameter_UnFullfilled", message: "parameter not passed correctly" })
      }

      console.log("sellerId", sellerId)
      console.log("sectionId", sectionId)

      if (syncWithEvenufy) {
        const result = await NotifyEvenuefy.revoked(sellerId, sectionId)
        // console.log(result)
        if (result.code != 200) {
          throw ({ code: "API_ERROR", message: "api occurred from API", data: result })
        }
      }

      const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}/${sellerId}`);
      await nodeRef.remove();
      if (user) {
        const _nodeRef = realDB.ref(
          `${REALDB_CONSTANT.SellerBaseData}/${sellerId}`
        );
        _nodeRef.update({
          admin: {
            uid: user.uid,
            email: user.email,
            timestamp: firebase.database.ServerValue.TIMESTAMP,
          },
          // evenuefyResponse: {
          //   [new Date().getTime()]: result
          // }
        });
      }
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const getDataForExcel = async () => {
  try {
    // Fetch base data with a limit
    const baseNodeRef = realDB.ref(`${REALDB_CONSTANT.SellerBaseData}`);
    const baseNodeDataSnapshot = await baseNodeRef.get();
    if (!baseNodeDataSnapshot.exists()) {
      console.warn("No base data found.");
      return;
    }
    const baseNodeData = Object.values(baseNodeDataSnapshot.val());

    // Fetch seller data with a limit
    const nodeRef = realDB.ref(`${REALDB_CONSTANT.Sellersdata}`);
    const nodeDataSnapshot = await nodeRef.get();
    const nodeData = nodeDataSnapshot.exists() ? Object.values(nodeDataSnapshot.val()) : [];

    // Transform seller data into a hash map for efficient lookup
    const nodeDataHash = nodeData.reduce((acc, seller) => {
      acc[seller.comapnyId] = seller;
      return acc;
    }, {});

    // Map and merge base and seller data
    const result = baseNodeData.map((base) => {
      // Extract and flatten admin data
      const { admin: adminData, region, section, ...baseDetails } = base;
      const flattenedAdminData = Object.fromEntries(
        Object.entries(adminData || {}).map(([key, value]) => [`Admin_${key}`, value])
      );

      // Fetch and flatten stall data if it exists
      const seller = nodeDataHash[base.comapnyId] || {};
      const stallsData = seller.stallData || {};
      const flattenedStallsData = Object.entries(stallsData).reduce((acc, [stallId, stall], index) => {
        const stallPrefix = `Stall${index + 1}_`;
        Object.entries(stall).forEach(([key, value]) => {
          // Only include keys that are not "section"
          if (!["section", "area"].includes(key)) {
            if (key === "vendor") {
              acc[`${stallPrefix}vendor_name`] = value.name || "";
              acc[`${stallPrefix}vendor_contact`] = value.phone || "";
            } else {
              acc[`${stallPrefix}${key}`] = value;
            }
          }
        });
        return acc;
      }, {});

      // Combine all data
      return {
        ...baseDetails,
        region: RegionData[region] || region,
        section: SectionData[section] || section,
        ...flattenedAdminData,
        ...flattenedStallsData,
      };
    });

    console.log(result);

    // Export to Excel
    const fileName = `IIJS_DATA_${Date.now()}.xlsx`;
    exportFile(result, "sheet1", fileName);
  } catch (error) {
    console.error("Error fetching or processing data:", error);
    throw error; // Rethrow for higher-level error handling
  }
};


export const exportFile = (
  data,
  sheetName,
  filename,
  headerOrdering = null
) => {
  try {
    console.log("exportFile");
    const wb = XLSX.utils.book_new();
    let wsAll = null;
    if (headerOrdering) {
      wsAll = XLSX.utils.json_to_sheet(data, {
        header: headerOrdering,
      });
    } else {
      wsAll = XLSX.utils.json_to_sheet(data);
    }
    XLSX.utils.book_append_sheet(wb, wsAll, sheetName);
    XLSX.writeFile(wb, filename);
  } catch (error) {
    console.error(error);
  }
};
window.getDataForExcel = getDataForExcel;

const newData ={}

const data = {
  "7000077866": {
    "comapnyId": "7000077866",
    "company_name": "MAHENDRA JEWELLERS",
    "region": "region_1",
    "section": "sectionData_2",
    "area": 18,
    "prime": "No",
    "primeAssure": "No"
  },
};
export const setSellersBaseData = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(newData);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

// console.log(data);

export const setNode = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

export const updateExhibitorData = (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const snapshot = realDB.ref(REALDB_CONSTANT.SellerBaseData);
      await snapshot.update(data);
      resolve();
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
};

// window.setSellersBaseData = setSellersBaseData;
